/**
 * =============================================================================
 * Project: vue-boilerplate
 * Created Date: 2017-10-26, 11:38:36
 * Author: Michał Rejman <michal.rejman@telestrada.pl>
 * =============================================================================
 * Last Modified: 2017-11-07, 15:14:22
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2017 Telestrada
 * =============================================================================
 */

import sRouter from '@/services/sRouter';

// COMPONENT ///////////////////////////////////////////////////////////////////
const Component = {
  name: 'HeaderNav',

  methods: {
    changeUrl(pathObject) {
      sRouter.changeUrl(pathObject, this.$router);
    },
  },
};

// EXPORT COMPONENT ////////////////////////////////////////////////////////////
export default Component;



// WEBPACK FOOTER //
// ./src/components/Panel/HeaderContainer/HeaderNav/component.js